// 配置文件
import { currentDev } from "./env";


const tsApiLink = {
  1: "https://iadm.wangyuedaojia.com/", //正式
  2: location.hostname.match(/[a-zA-Z]+/) ? "https://iadmtest.wangyuedaojia.com" : location.origin, //内测
  // 2: "https://iadmtest.wangyuedaojia.com", //内测
  3: "https://iadmpre.wangyuedaojia.com", //预发布
};

const apiLinkList = {
  1: 'https://iadm.wangyuedaojia.com', //生产
  2:  location.hostname.match(/[a-zA-Z]+/) ? 'https://iadmtest.wangyuedaojia.com' : location.origin, //内测
  // 2: 'https://iadmtest.wangyuedaojia.com', //内测
  3: 'https://iadmpre.wangyuedaojia.com' //预发布
}
const partnerApiList = {
  1: 'https://iptn.wangyuedaojia.com', //生产
  2:  location.hostname.match(/[a-zA-Z]+/) ? 'https://iptntest.wangyuedaojia.com' : location.origin, //内测
  3: 'https://iptnpre.wangyuedaojia.com' //预发布
}

const tsApiBaseUrl = tsApiLink[currentDev];
const wyApiBaseUrl = apiLinkList[currentDev];
const partnerApiBaseUrl = partnerApiList[currentDev];

const config = {
  terminal: 1, //终端
  title: '后台管理系统', //网站默认标题
  version: '1.1.0', //版本号
  baseUrl: `${import.meta.env.VITE_APP_BASE_URL || ''}/`, //请求接口域名
  urlPrefix: '', //请求默认前缀
  timeout: 30 * 1000, //请求超时时长
  OssUrl: 'http://oss.wangyuedaojia.com/'
}
// 如果本地缓存有接口地址则使用缓存的接口地址，用于调试
// if (localStorage.VITE_APP_BASE_URL) {
// config.baseUrl = localStorage.VITE_APP_BASE_URL
// }

const collegeLinkList = {
  1: 'https://iadm.wangyuedaojia.com/course-admin/',
  2: 'https://iadmtest.wangyuedaojia.com/course-admin/',
  3: 'https://iadmpre.wangyuedaojia.com/course-admin/',
}

config.baseUrl = collegeLinkList[currentDev]

export { tsApiBaseUrl, wyApiBaseUrl, config, partnerApiBaseUrl };
